import { put } from 'redux-saga/effects';
import { AxiosResponse } from 'axios';

import { getComments, addComment } from './service';
import {
	getCommentsSuccessAction,
	getCommentsFailureAction,
	addCommentSuccessAction,
} from './action';
import { addCommentToSharedAction } from '../SharedSnap/action';

export function* getCommentsSaga(action: any) {
	const { id, callback } = action.payload;
	try {
		const { data }: AxiosResponse = yield getComments(id);
		yield put(getCommentsSuccessAction(data.data));
	} catch (e) {
		yield put(getCommentsFailureAction(e as Error));
	} finally {
		callback && callback();
	}
}

export function* addCommentSaga(action: any) {
	const { data, callback } = action.payload;
	try {
		yield addComment(data);
		yield put(addCommentToSharedAction(data));
		yield put(addCommentSuccessAction(data));
	} catch (e) {
		console.log(e);
	} finally {
		callback && callback();
	}
}
